import {
  ISiteVisitQuestion,
  SiteVisitQuestionType,
  isMapQuestion,
  isTextQuestion,
  isNumberQuestion,
  isSelectQuestion,
  isPhotosQuestion,
  isFilesQuestion,
} from '../types';
import { questionTypeConfig } from '../styles/questionCard';

export const getQuestionTypeLabel = (type: SiteVisitQuestionType): string => {
  return questionTypeConfig.labels[type] || type;
};

export const getQuestionTypeColor = (type: SiteVisitQuestionType): string => {
  return questionTypeConfig.colors[type] || 'default';
};

export const formatQuestionResult = (question: ISiteVisitQuestion): string => {
  if (!question.result) {
    return 'Not filled';
  }

  if (isMapQuestion(question)) {
    const pointsCount = question.result.points?.length || 0;
    if (pointsCount === 0) return 'Not filled';
    return `${pointsCount} point${pointsCount > 1 ? 's' : ''}`;
  }

  if (isTextQuestion(question)) {
    const value = question.result.value?.trim();
    if (!value) return 'Not filled';
    return value.length > 50 ? `${value.substring(0, 50)}...` : value;
  }

  if (isNumberQuestion(question)) {
    const value = question.result.value;
    if (value === undefined || value === null) return 'Not filled';
    return value.toString();
  }

  if (isSelectQuestion(question)) {
    const value = question.result.value;
    if (!value) return 'Not filled';
    if (Array.isArray(value)) {
      return value.length > 0 ? value.join(', ') : 'Not filled';
    }
    return value;
  }

  if (isPhotosQuestion(question)) {
    const photosCount = question.result.photos?.length || 0;
    if (photosCount === 0) return 'Not filled';
    return `${photosCount} photos`;
  }

  if (isFilesQuestion(question)) {
    const filesCount = question.result.files?.length || 0;
    if (filesCount === 0) return 'Not filled';
    return `${filesCount} files`;
  }

  return JSON.stringify((question as ISiteVisitQuestion).result || {});
};
